const urlsToExecuteUpdate = [
    '/calculators/home-affordability-calculator',
    '/calculators/mortgage-calculator',
    '/calculators/rent-vs-buy-calculator',
    '/calculators/refinance-calculator',
    '/calculators/home-equity-calculator',
];

module.exports = urlsToExecuteUpdate;